import axios from "axios";
import config from "./config";

const proxyServer = config.supportApi +"routes-app/invoice";

export const GetInvoice = (userToken) => {
  const criterion = { userToken };

  return axios
    .post(proxyServer + "/get-invoice-lists", { criterion })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};
